<template>
  <div class="content-wrapper configuration-base">
    <menuComponent
      :menuItems="steps"
      :currentStep="steps[this.currentBaseStep]"
      :results="results"
      :price="price"
      v-on:set-element="setElement"
      v-on:go-back="goBack()"
      v-on:go-next="goNext()"
    ></menuComponent>
    <div class="configurator-content">
      <keep-alive>
        <imagerComponent
          v-if="reRenderImager"
          :componentsConfig="componentsConfig"
          :bikeConfiguration="bikeConfiguration"
          :results="results"
        >
        </imagerComponent>
      </keep-alive>
      <component
        v-bind:is="getConfigurationStep"
        v-on:go-next="goNext"
        v-on:go-back="goBack"
        v-on:set-error="(e) => $emit('set-error', e)"
        v-on:set-measure="setMeasure"
        v-on:set-primary-color="setPrimaryColor"
        v-on:set-secondary-color="setSecondaryColor"
        v-on:set-frame-finish="setFrameFinish"
        v-on:set-stem="setStem"
        v-on:set-handlebars="setHandlebars"
        v-on:set-bartape="setBartape"
        v-on:set-groupset="setGroupset"
        v-on:set-crankset="setCrankset"
        v-on:set-bottlecages="setBottlecages"
        v-on:set-seatpost="setSeatpost"
        v-on:set-seatclamp="setSeatclamp"
        v-on:set-saddle="setSaddle"
        v-on:set-wheels="setWheels"
        v-on:set-tyres="setTyres"
        v-on:set-fork="(e) => $emit('set-fork', e)"
        v-on:set-colour-type="setColourType"
        v-on:update-title-font="setTitleFont"
        v-on:update-title-text="setTitleText"
        v-on:component-color-selected="selectColor"
        v-on:save-configuration-as-default="saveConfigurationAsDefault"
        v-on:finish-configuration="finishConfiguration"
        :bikeConfiguration="bikeConfiguration"
        :questionAnswers="questionAnswers"
        :bikes="bikes"
        :bike="bike"
        :configuratorSteps="phases.configuration"
        :currentStep="currentStep"
        :results="results"
        :components="components"
        :measures="measures"
        :colors="colors"
        :componentsConfig="componentsConfig"
        :relatedCrankset="relatedCrankset"
        :loggedUser="loggedUser"
        :defaultConfigurations="defaultConfigurations"
        :electronicMode="electronicMode"
      ></component>
    </div>
    <div v-if="loadedFromDb" class="go-to-summary">
      <button class="btn btn-outline-primary" v-on:click="backToSummary">
        BACK TO SUMMARY
      </button>
    </div>
    <footerComponent
      :price="price"
      :bike="bike"
      v-on:goto-preconfigured="$emit('goto-preconfigured')"
    ></footerComponent>
  </div>
</template>

<script>
import Vue from "vue";

import menuComponent from "../../shared/menu.vue";
import imagerComponent from "../../shared/imager.vue";
import footerComponent from "../../shared/footer.vue";

import ConfigurationBarsAndTape from "./bars.vue";
import ConfigurationCabling from "./cabling.vue";
import ConfigurationCagesBottles from "./cages-bottles.vue";
import ConfigurationColour from "./colour.vue";
import ConfigurationFork from "./fork.vue";
import ConfigurationFrame from "./frame.vue";
import ConfigurationPersonalTitle from "./personal-title.vue";
import ConfigurationGroupset from "./groupset.vue";
import ConfigurationSaddle from "./saddle-e-tape.vue";
import ConfigurationSeatPost from "./seat-post.vue";
import ConfigurationSeatClamp from "./seat-clamp.vue";
import ConfigurationStem from "./stem.vue";
import ConfigurationTyres from "./tyres.vue";
import ConfigurationWheels from "./wheels.vue";

Vue.component("configuration-bars", ConfigurationBarsAndTape);
Vue.component("configuration-cabling", ConfigurationCabling);
Vue.component("configuration-cages-bottles", ConfigurationCagesBottles);
Vue.component("configuration-colour", ConfigurationColour);
Vue.component("configuration-fork", ConfigurationFork);
Vue.component("configuration-frame", ConfigurationFrame);
Vue.component("configuration-personal-title", ConfigurationPersonalTitle);
Vue.component("configuration-groupset", ConfigurationGroupset);
Vue.component("configuration-saddle-and-tape", ConfigurationSaddle);
Vue.component("configuration-seat-post", ConfigurationSeatPost);
Vue.component("configuration-seat-clamp", ConfigurationSeatClamp);
Vue.component("configuration-stem", ConfigurationStem);
Vue.component("configuration-tyres", ConfigurationTyres);
Vue.component("configuration-wheels", ConfigurationWheels);

export default {
  name: "configuration-base",
  data() {
    return {
      configurationStep: 0,
    };
  },
  components: {
    menuComponent,
    imagerComponent,
    footerComponent,
  },
  props: [
    "bike",
    "bikes",
    "configuratorSteps",
    "currentStep",
    "currentBaseStep",
    "components",
    "questionAnswers",
    "currentBike",
    "phases",
    "results",
    "steps",
    "price",
    "measures",
    "colors",
    "componentsConfig",
    "bikeConfiguration",
    "relatedCrankset",
    "loadedFromDb",
    "loggedUser",
    "defaultConfigurations",
    "electronicMode",
    "reRenderImager",
  ],
  computed: {
    getConfigurationStep: function () {
      return "configuration-" + this.steps[this.currentBaseStep];
    },
  },
  methods: {
    goNext: function () {
      if (this.currentBaseStep < this.steps.length - 1) {
        //this.configurationStep++;
        this.$emit("increment-base-step");
      } else {
        this.$emit("go-next");
      }
    },
    goBack: function () {
      if (this.currentBaseStep > 0) {
        //this.configurationStep--;
        this.$emit("decrement-base-step");
      } else {
        this.$emit("go-back");
      }
    },
    setElement: function (item, index) {
      this.$emit("set-base-step", index);
      //this.configurationStep = index;
    },
    setMeasure: function (type, measure) {
      this.$emit("set-measure", type, measure);
    },
    setPrimaryColor: function (e) {
      this.$emit("set-primary-color", e);
    },
    setSecondaryColor: function (e) {
      this.$emit("set-secondary-color", e);
    },
    setColourType: function (e) {
      this.$emit("set-colour-type", e);
    },
    setTitleFont: function (e) {
      this.$emit("update-title-font", e);
    },
    setTitleText: function (e) {
      this.$emit("update-title-text", e);
    },
    setFrameFinish: function (e) {
      this.$emit("set-frame-finish", e);
    },
    setStem: function (e) {
      this.$emit("set-stem", e);
    },
    setHandlebars: function (e) {
      this.$emit("set-handlebars", e);
    },
    setBartape: function (e) {
      this.$emit("set-bartape", e);
    },
    setGroupset: function (e) {
      this.$emit("set-groupset", e);
    },
    setCrankset: function (e) {
      this.$emit("set-crankset", e);
    },
    setBottlecages: function (e) {
      this.$emit("set-bottlecages", e);
    },
    setSeatpost: function (e) {
      this.$emit("set-seatpost", e);
    },
    setSeatclamp: function (e) {
      this.$emit("set-seatclamp", e);
    },
    setSaddle: function (e) {
      this.$emit("set-saddle", e);
    },
    setWheels: function (e) {
      this.$emit("set-wheels", e);
    },
    setTyres: function (e) {
      this.$emit("set-tyres", e);
    },
    getResults: function () {
      return {
        questionaire: this.questionAnswers,
        configuration: this.results,
      };
    },
    selectColor: function (color, componentId, componentType) {
      this.$emit("component-color-selected", color, componentId, componentType);
    },
    backToSummary: function () {
      this.$emit("back-to-summary");
    },
    saveConfigurationAsDefault: function (n) {
      this.$emit("save-configuration-as-default", n);
    },
    finishConfiguration: function() {
      this.$emit("finish-configuration");
    },
  },
};
</script>

<style lang="scss" scoped>
.configuration-base {
}

.go-to-summary {
  text-align: right;
  margin-bottom: 20px;
  padding-right: 56px;
  position: absolute;
  margin-top: -60px;
}
@media (max-width: 767px) {
  .go-to-summary {
    position: relative;
    margin-top: auto;
    padding: 0px;
    width: 100%;
    .btn {
      width: 100%;
    }
  }
}
</style>
